import * as React from 'react';

export interface IModalTitleProps extends React.HTMLProps<HTMLDivElement> {
}

export const ModalTitle = (props: any) => <div className="modal-title" {...props}>{props.children}</div>;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalTitle.tsx